import React from 'react';

import { useIntl } from 'react-intl-next';

import messages from './messages';
import { PaginationDetailsStyled } from './styled';
import { type PaginationDetailsProps } from './types';

export const PaginationDetails: React.FC<PaginationDetailsProps> = ({ itemsCount, totalCount }) => {
	const { formatMessage } = useIntl();

	return (
		<PaginationDetailsStyled>
			{formatMessage(messages.ofTotalCount, {
				itemsCount,
				totalCount,
			})}
		</PaginationDetailsStyled>
	);
};
